import { Suspense, lazy, useEffect } from 'react';

const Upgrade = lazy(() => import('../pages/Upgrade/Upgrade'));
const Share = lazy(() => import('../pages/Share/Share'));
const Upload = lazy(() => import('../pages/Upload/Upload')) ;
const Capture = lazy(() => import('../pages/Upload/Capture/Capture'));
const Review = lazy(() => import('../pages/Upload/Review/Review'));
const PrintModal = lazy(() => import('../pages/Print/Print'));
const LoginModal = lazy(() => import('../pages/LoginModal/LoginModal'));
const Accounts = lazy(() => import('../pages/Account/Accounts'));
const Account = lazy(() => import('../pages/Account/Account'));
// import Account from '../pages/Account/Account';

import App from '../App';

import { Route, Routes } from "react-router-dom";
import Loading from '../components/Loading/Loading';
import Purchase from '../pages/Purchase/Purchase';

function FishyRoutes() {

  useEffect(() => {
    setTimeout(async () => {
      console.log('starting to load lazy routes');
      await import('../pages/Upload/Capture/Capture');
      await import('../pages/Upload/Review/Review');
      console.log('done loading lazy routes');
    }, 500)
  }, [])

  return (
          <Routes>
            <Route path="/" >
                <Route index element={<App openMenu={true}/>} />
                <Route element={<App openMenu={false}/>} >
                    <Route path="/upload" element={<Suspense fallback={<Loading/>}><Upload /></Suspense>} />
                    <Route path="/capture" element={<Suspense fallback={<Loading/>}><Capture /></Suspense>} />
                    <Route path="/capturing" element={<Suspense fallback={<Loading/>}><Review /></Suspense>} />
                    <Route path="/print" element={<Suspense fallback={<Loading/>}><PrintModal /></Suspense>} />
                    <Route path="/login" element={<Suspense fallback={<Loading/>}><LoginModal /></Suspense>} />
                    <Route path="/upgrade" element={<Suspense fallback={<Loading/>}><Upgrade /></Suspense>} />
                    <Route path="/share" element={<Suspense fallback={<Loading/>}><Share /></Suspense>} />
                    <Route path="/account/:id" element={<Suspense fallback={<Loading/>}><Account /></Suspense>} />
                    <Route path="/account" element={<Suspense fallback={<Loading/>}><Accounts /></Suspense>} />
                    <Route path="/purchase" element={<Suspense fallback={<Loading/>}><Purchase /></Suspense>} />
                </Route>
            </Route>
            <Route path="/aquarium/:id" element={<App aquariumPath={true}/>} >
                <Route path="/aquarium/:id/upload" element={<Suspense fallback={<Loading/>}><Upload /></Suspense>} />
                <Route path="/aquarium/:id/capture" element={<Suspense fallback={<Loading/>}><Capture /></Suspense>} />
                <Route path="/aquarium/:id/capturing" element={<Suspense fallback={<Loading/>}><Review /></Suspense>} />
                <Route path="/aquarium/:id/print" element={<Suspense fallback={<Loading/>}><PrintModal /></Suspense>} />
                <Route path="/aquarium/:id/login" element={<Suspense fallback={<Loading/>}><LoginModal /></Suspense>} />
                <Route path="/aquarium/:id/upgrade" element={<Suspense fallback={<Loading/>}><Upgrade /></Suspense>} />
                <Route path="/aquarium/:id/share" element={<Suspense fallback={<Loading/>}><Share /></Suspense>} />
            </Route>
            <Route path="/c/:connectToken" element={<App />}>
              <Route path="/c/:connectToken/upload" element={<Suspense fallback={<Loading/>}><Upload /></Suspense>} />
              <Route path="/c/:connectToken/capture" element={<Suspense fallback={<Loading/>}><Capture /></Suspense>} />
              <Route path="/c/:connectToken/capturing" element={<Suspense fallback={<Loading/>}><Review /></Suspense>} />
              <Route path="/c/:connectToken/print" element={<Suspense fallback={<Loading/>}><PrintModal /></Suspense>} />
              <Route path="/c/:connectToken/login" element={<Suspense fallback={<Loading/>}><LoginModal /></Suspense>} />
              <Route path="/c/:connectToken/upgrade" element={<Suspense fallback={<Loading/>}><Upgrade /></Suspense>} />
              <Route path="/c/:connectToken/share" element={<Suspense fallback={<Loading/>}><Share /></Suspense>} />
            </Route>
            <Route path="*" element={<App />} />
          </Routes>     
  )
}

export default FishyRoutes;